/*******************************************************************************
 * Copyright (c) 2024. dnote.ai
 *
 * @project DNOTE.AI-Frontend
 * @author dnote.ai
 * @copyright Dnote.ai All rights reserved
 ******************************************************************************/

export const DEFAULT_PAGE = {
    totalPages      : 0,
    totalElements   : 0,
    content         : [],
    currentPage     : 1
}